import React, { useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from "reactstrap";
import "./style.css";

const Revocation = ({ open, handleClose, handleRevocation, revocationLoading }) => {
  const [revocationCode, setRevocationCode] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e) => {
    const value = e.target.value;
    if (!value) {
      setErrorMessage("This field is required");
    }
    setRevocationCode(value);
  };

  const handleClick = () => {
    if (revocationCode?.length === 0) {
      setErrorMessage("This field is required");
      return;
    }
    handleRevocation(revocationCode);
  };

  return (
    <Modal className="modal-2fa" isOpen={open} toggle={handleClose} centered>
      <ModalHeader toggle={handleClose}>Recovery Code</ModalHeader>

      <ModalBody>
        <div className="text-center mb-4">
          <p className="font-weight-bold mb-2">
            Remove Two Factor Authentication
          </p>
          <p className="text-muted small">
            To complete the removal of two-factor authentication from your
            account, please enter the revocation code you saved when you first
            set up 2FA.
          </p>
        </div>

        <div className="mb-4">
          <h6 className="font-weight-bold text-center mb-3">
            ENTER REVOCATION CODE:
          </h6>

          <input
            type="text"
            placeholder="Enter your Revocation code"
            className="custom-inputbox"
            onChange={handleChange}
            value={revocationCode}
          />
          {errorMessage && <p className="text-danger text-center mt-2">{errorMessage}</p>}
        </div>
      </ModalBody>

      <ModalFooter className="d-flex justify-content-center">
        <Button color="secondary" onClick={handleClose}>
          Cancel
        </Button>

        <Button
          color="primary"
          onClick={handleClick}
          disabled={!revocationCode || revocationLoading}>
          Reset 2FA
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default Revocation;
